import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PageLayout from '../../../components/layout/PageLayout';
import DataTable from '../../../components/ui/DataTable';
import ActionIconButton from '../../../components/ui/ActionIconButton';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { MascaraTelefone } from '../../../utils/MascaraTelefone';

function Leads() {

    const [leadsList, setLeadsList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/leads/recuperaveis`)
            .then(response => {
                setLeadsList(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => console.error("Erro ao buscar dados:", error))
            .finally(() => setLoading(false));
    }, []);

    const columns = [
        { key: 'idLead', label: 'ID', width: 72, render: (lead) => lead?.idLead },
        { key: 'nome', label: 'Nome', render: (lead) => lead?.nome || '—', sx: { fontWeight: 500 } },
        { key: 'email', label: 'E-mail', render: (lead) => lead?.email || '—' },
        { key: 'telefone', label: 'Telefone', render: (lead) => MascaraTelefone(lead?.telefone) || '—' },
        { key: 'stepAtual', label: 'Parou em', render: (lead) => (lead?.stepAtual ? `Step ${lead.stepAtual}` : '—') },
        { key: 'acoes', label: 'Ações', align: 'right', width: 80, render: () => <ActionIconButton title="Editar" icon={<EditOutlinedIcon fontSize="small" />} pending /> },
    ];

    return (
        <PageLayout
            title="Leads perdidos"
            subtitle="Leads que iniciaram o cadastro e não concluíram."
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Leads' }]}
        >
            <DataTable
                columns={columns}
                rows={leadsList}
                getRowKey={(lead, i) => lead?.idLead ?? i}
                loading={loading}
                emptyMessage="Nenhum lead perdido encontrado."
            />
        </PageLayout>
    );
}

export default Leads;
